(function() {
  'use strict';

  // Get section ID from script data attribute
  var scriptTag = document.currentScript;
  var sectionId = scriptTag ? scriptTag.getAttribute('data-section-id') : null;
  if (!sectionId) {
    console.error('[EventCollectionTabs] Missing section ID');
    return;
  }

  var ITEMS_PER_PAGE = 48;

  var mainProducts = [];
  var pickupProducts = [];
  var mainCurrentPage = 1;
  var pickupCurrentPage = 1;
  var activeTab = 'main';
  var mainVendors = [];
  var pickupVendors = [];
  var currentMainVendor = null;
  var currentPickupVendor = null;

  // CDN URL replacement for China site
  var isInternational = window.location.host.indexOf('freedomenduro.com') >= 0;
  function transformCdnUrl(url) {
    if (!url || isInternational) return url;
    var chinaCdn = '//shop.cdn.freedomenduro.cn/cdn/shop/';
    // Use String.prototype.split and join to avoid layout CDN replacement
    var patterns = [
      ['//shop.freedomenduro.cn/cdn/shop/', chinaCdn],
      ['//freedomenduro.cn/cdn/shop/', chinaCdn],
      ['//cdn.shopify.com/s/files/1/0591/1448/7966/', chinaCdn],
      ['//cdn.shopifycdn.net/s/files/1/0591/1448/7966/', chinaCdn]
    ];
    var result = url;
    for (var i = 0; i < patterns.length; i++) {
      result = result.split(patterns[i][0]).join(patterns[i][1]);
    }
    return result;
  }

  // State display helpers
  function showLoadingOverlay(tabType) {
    var gridEl = document.getElementById(tabType + '-products-grid');
    var loadingEl = document.getElementById(tabType + '-loading');
    var overlayEl = document.getElementById(tabType + '-loading-overlay');

    // If products exist, show overlay; otherwise show initial loading state
    if (gridEl && gridEl.children.length > 0) {
      overlayEl.style.display = 'flex';
    } else {
      loadingEl.style.display = 'flex';
    }
  }
  function hideLoading(tabType) {
    document.getElementById(tabType + '-loading').style.display = 'none';
    document.getElementById(tabType + '-loading-overlay').style.display = 'none';
  }
  function showEmptyState(tabType) {
    var loadingEl = document.getElementById(tabType + '-loading');
    var gridEl = document.getElementById(tabType + '-products-grid');
    gridEl.innerHTML = '';
    loadingEl.innerHTML = '<p class="event-state-text">暂无商品</p>';
    loadingEl.style.display = 'flex';
  }
  function showErrorState(tabType) {
    var loadingEl = document.getElementById(tabType + '-loading');
    loadingEl.innerHTML = '<p class="event-state-text">加载失败，请刷新页面重试</p>';
    loadingEl.style.display = 'flex';
  }
  var brandMap = {}; // Store brand logo data

  function getEventData() {
    return window.EventData || null;
  }

  // Fetch brand data from API
  function fetchBrandData(vendorNames) {
    if (!vendorNames || vendorNames.length === 0) {
      return Promise.resolve([]);
    }

    var config = window.EventPricingConfig;
    var apiBase = config && config.api ? config.api.base : 'https://apps.freedomenduro.cn';
    var namesParam = encodeURIComponent(vendorNames.join(','));

    return fetch(apiBase + '/brand/list?names=' + namesParam)
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.success && data.data) {
          // Build vendor name -> brand data map (case-insensitive)
          data.data.forEach(function(brand) {
            if (brand.name) {
              brandMap[brand.name.toLowerCase()] = {
                name: brand.name,
                logo_url: brand.logo_url
              };
            }
          });
          return data.data;
        }
        return [];
      })
      .catch(function(error) {
        console.warn('[EventCollectionTabs] Failed to fetch brand data:', error);
        return [];
      });
  }

  // Get brand data for a vendor
  function getBrandData(vendor) {
    var lowerVendor = vendor.toLowerCase();
    if (brandMap[lowerVendor]) {
      return brandMap[lowerVendor];
    }
    return { name: vendor, logo_url: null };
  }

  function getEventToken() {
    var value = '; ' + document.cookie;
    var parts = value.split('; event_token=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function getEventSlug() {
    var value = '; ' + document.cookie;
    var parts = value.split('; event_slug=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function formatMoney(price) {
    var num = parseFloat(price) || 0;
    return '¥' + num.toFixed(2);
  }

  // Tab switching
  var tabButtons = document.querySelectorAll('#event-tabs-' + sectionId + ' .tab-button');
  tabButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var tab = this.getAttribute('data-tab');
      switchTab(tab);
    });
  });

  function switchTab(tab) {
    activeTab = tab;

    // Update buttons
    tabButtons.forEach(function(btn) {
      if (btn.getAttribute('data-tab') === tab) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Update content
    var contents = document.querySelectorAll('#event-tabs-' + sectionId + ' .tab-content');
    contents.forEach(function(content) {
      if (content.id === 'tab-' + tab) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  // Fetch collection data (vendors + products + pagination) in one request
  function fetchCollectionData(handle, page, vendor) {
    if (!handle) return Promise.resolve({ vendors: [], products: [], pagination: null });
    var url = '/collections/' + handle + '?view=event.json';
    if (vendor) url += '&filter.p.vendor=' + encodeURIComponent(vendor);
    if (page && page > 1) url += '&page=' + page;
    // Add cache buster to avoid CDN caching issues
    url += '&_t=' + Date.now();
    console.log('[EventCollectionTabs] Fetching URL:', url);
    return fetch(url, { cache: 'no-store' })
      .then(function(response) {
        console.log('[EventCollectionTabs] Response status:', response.status);
        return response.text();
      })
      .then(function(text) {
        console.log('[EventCollectionTabs] Raw response for', handle + ':', text.substring(0, 500));
        var data = JSON.parse(text);
        return {
          vendors: Array.isArray(data.vendors) ? data.vendors.sort() : [],
          products: data.products || [],
          pagination: data.pagination || null
        };
      })
      .catch(function(error) {
        console.warn('[EventCollectionTabs] Failed to fetch collection data:', handle, error);
        return { vendors: [], products: [], pagination: null };
      });
  }

  // Render brand filter buttons (with logos if available)
  function renderBrandFilter(tabType, vendors) {
    if (vendors.length == 0) {
      // Hide filter if no brands
      document.getElementById(tabType + '-brand-filter').style.display = 'none';
      return;
    }

    var buttonsContainer = document.getElementById(tabType + '-brand-buttons');
    var filterContainer = document.getElementById(tabType + '-brand-filter');

    // Fetch brand data first, then render buttons
    fetchBrandData(vendors).then(function() {
      var html = '<button class="brand-button active" onclick="window.filterTabByBrand(\'' + tabType + '\', null)">全部</button>';

      vendors.forEach(function(vendor) {
        var brandData = getBrandData(vendor);
        var hasLogo = !!brandData.logo_url;
        var buttonClass = 'brand-button' + (hasLogo ? ' has-logo' : '');

        if (hasLogo) {
          var logoUrl = transformCdnUrl(brandData.logo_url);
          html += '<button class="' + buttonClass + '" onclick="window.filterTabByBrand(\'' + tabType + '\', \'' + vendor.replace(/'/g, "\\'") + '\')">' +
                  '<img src="' + logoUrl + '" alt="' + brandData.name + '" />' +
                  '</button>';
        } else {
          html += '<button class="' + buttonClass + '" onclick="window.filterTabByBrand(\'' + tabType + '\', \'' + vendor.replace(/'/g, "\\'") + '\')">' +
                  vendor +
                  '</button>';
        }
      });

      buttonsContainer.innerHTML = html;
      filterContainer.style.display = 'block';
    });
  }

  // Update button active states
  function updateBrandButtonStates(tabType, vendor) {
    var buttons = document.querySelectorAll('#' + tabType + '-brand-buttons .brand-button');
    buttons.forEach(function(btn) {
      var btnText = btn.textContent.trim();
      var btnImg = btn.querySelector('img');
      var btnVendor = btnImg ? btnImg.alt : btnText;

      if ((vendor === null && btnText === '全部') || btnVendor === vendor) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Filter products by brand for specific tab (server-side filtering)
  window.filterTabByBrand = function(tabType, vendor) {
    var handle = tabType === 'main' ? mainCollectionHandle : pickupCollectionHandle;

    // Update button states immediately
    updateBrandButtonStates(tabType, vendor);

    if (tabType === 'main') {
      currentMainVendor = vendor;
    } else {
      currentPickupVendor = vendor;
    }

    showLoadingOverlay(tabType);

    // Server-side filtering via Liquid template
    fetchCollectionData(handle, 1, vendor).then(function(data) {
      if (tabType === 'main') {
        mainProducts = data.products;
        mainPagination = data.pagination;
        mainCurrentPage = 1;
      } else {
        pickupProducts = data.products;
        pickupPagination = data.pagination;
        pickupCurrentPage = 1;
      }
      renderProducts(tabType, data.products, data.pagination);
      requestAnimationFrame(function() {
        if (window.EventPricing && window.EventPricing.updateProductGridPrices) {
          window.EventPricing.updateProductGridPrices();
        }
      });
    });
  };

  function renderProduct(product, index) {
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;
    if (!variant) return '';

    // Build all variants data for pickup_available check
    var allVariants = [];
    if (product.variants) {
      product.variants.forEach(function(v) {
        allVariants.push({ id: v.id, sku: v.sku || '' });
      });
    }

    var imageUrl = '';
    if (product.images && product.images.length > 0) {
      imageUrl = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      imageUrl = transformCdnUrl(imageUrl);
    }

    var priceHtml = '';
    // Shopify API returns price in cents, convert to yuan
    var priceYuan = (parseFloat(variant.price) || 0) / 100;
    var compareAtYuan = (parseFloat(variant.compare_at_price) || 0) / 100;

    if (priceYuan > 0) {
      priceHtml = '<span style="font-weight:bold;color:#e32e00;">' + formatMoney(priceYuan) + '</span>';
      if (compareAtYuan > priceYuan) {
        priceHtml += ' <del style="color:#999;margin-left:8px;">' + formatMoney(compareAtYuan) + '</del>';
      }
    } else {
      priceHtml = '<span style="font-weight:bold;color:#e32e00;">免费</span>';
    }

    // For activity page, use compare_at_price as the crossed-out price if available
    var originalPriceForActivity = (compareAtYuan > priceYuan) ? compareAtYuan : priceYuan;

    var badgeConfig = window.EventPricingConfig && window.EventPricingConfig.badges;
    var domesticBadge = badgeConfig ? badgeConfig.domestic : { text: '国内现货', tag: '是否现货_国内现货', background: '#F07B67', color: '#fff', className: 'badge-domestic-swatch' };
    var commonStyles = badgeConfig ? badgeConfig.common : { padding: '5px 10px', fontSize: '12px', fontWeight: 'bold', borderRadius: '4px', position: 'absolute', bottom: '10px', right: '10px', zIndex: '10' };

    var tags = product.tags || '';
    var hasDomesticStock = tags.indexOf(domesticBadge.tag) !== -1;
    var badgeHtml = '';
    var baseStyle = 'position:' + commonStyles.position + ';bottom:' + commonStyles.bottom + ';right:' + commonStyles.right + ';z-index:' + commonStyles.zIndex + ';padding:' + commonStyles.padding + ';font-size:' + commonStyles.fontSize + ';font-weight:' + commonStyles.fontWeight + ';border-radius:' + commonStyles.borderRadius + ';' + (commonStyles.width ? 'width:' + commonStyles.width + ';box-sizing:border-box;text-align:center;' : '');

    if (hasDomesticStock) {
      // Always include inventory-badge class so updateProductGridPickupBadge can find it
      badgeHtml = '<span class="inventory-badge ' + domesticBadge.className + '" style="' + baseStyle + 'background:' + domesticBadge.background + ';color:' + domesticBadge.color + ';">' + domesticBadge.text + '</span>';
    } else {
      badgeHtml = '<span class="inventory-badge" style="display:none;' + baseStyle + '"></span>';
    }

    var eventName = (window.EventData && window.EventData.name) ? window.EventData.name : '活动';

    return '<div class="product animate borders three brands animate-loop-' + (index % 6) + '" ' +
           'data-product-id="' + product.id + '" ' +
           'data-variant-id="' + variant.id + '" ' +
           'data-sku="' + (variant.sku || '') + '" ' +
           'data-original-price="' + priceYuan + '" ' +
           'data-compare-price="' + compareAtYuan + '" ' +
           "data-all-variants='" + JSON.stringify(allVariants) + "'>" +
      '<div class="product-border text-left relative">' +
        '<div class="product-thumb-container">' +
          '<div class="relative">' +
            badgeHtml +
            '<div class="product-thumb text-center">' +
              '<a href="/products/' + product.handle + '" title="' + product.title + '" class="product-thumb-main">' +
                (imageUrl ? '<img src="' + imageUrl + '" alt="' + product.title + '" />' : '') +
              '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="product-details">' +
          '<div class="product-title">' +
            '<h4><a href="/products/' + product.handle + '" title="' + product.title + '">' + product.title + '</a></h4>' +
          '</div>' +
          '<div class="product-variants purchase-section">' +
            '<div class="product-price" id="product-price-' + product.id + '-' + sectionId + '">' +
              '<div class="activity-price-section" style="display:none;">' +
                '<div style="margin-bottom:4px;">' +
                  '<span class="price-label-name activity-badge" style="background:#e32e00;color:#fff;padding:3px 8px;border-radius:3px;font-size:11px;font-weight:bold;margin-right:6px;">' + ((window.EventData && window.EventData.price_label) || (eventName + '专享价')) + '</span>' +
                  '<span class="activity-price-value" style="color:#e32e00;font-weight:bold;font-size:1.1em;"></span>' +
                '</div>' +
                '<div style="font-size:11px;color:#666;white-space:nowrap;">' +
                  '<span>日常价</span>' +
                  '<span class="activity-selling-price" style="margin-left:2px;"></span>' +
                  '<span class="activity-compare-label" style="color:#999;margin-left:5px;">原价</span>' +
                  '<del class="activity-original-price" style="color:#999;margin-left:2px;"></del>' +
                '</div>' +
              '</div>' +
              '<div class="normal-price-section">' +
                priceHtml +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderProducts(tabType, products, pagination) {
    var gridEl = document.getElementById(tabType + '-products-grid');

    if (products.length === 0) {
      showEmptyState(tabType);
      return;
    }

    var html = '';
    for (var i = 0; i < products.length; i++) {
      html += renderProduct(products[i], i);
    }

    gridEl.innerHTML = html;

    // Use server-side pagination info
    if (pagination) {
      renderPagination(tabType, pagination.current_page, pagination.total_pages, pagination.total_items);
    }

    hideLoading(tabType);
  }

  function renderPagination(tabType, currentPage, totalPages, totalItems) {
    var paginationEl = document.getElementById(tabType + '-pagination');
    if (totalPages <= 1) {
      paginationEl.innerHTML = '';
      return;
    }

    var html = '<button onclick="window.eventTabsPagination(\'' + tabType + '\', ' + (currentPage - 1) + ')" ' +
               (currentPage === 1 ? 'disabled' : '') + '>上一页</button>';

    // Show page numbers
    var startPage = Math.max(1, currentPage - 2);
    var endPage = Math.min(totalPages, currentPage + 2);

    if (startPage > 1) {
      html += '<button onclick="window.eventTabsPagination(\'' + tabType + '\', 1)">1</button>';
      if (startPage > 2) {
        html += '<span>...</span>';
      }
    }

    for (var i = startPage; i <= endPage; i++) {
      html += '<button onclick="window.eventTabsPagination(\'' + tabType + '\', ' + i + ')" ' +
              (i === currentPage ? 'class="active"' : '') + '>' + i + '</button>';
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        html += '<span>...</span>';
      }
      html += '<button onclick="window.eventTabsPagination(\'' + tabType + '\', ' + totalPages + ')">' + totalPages + '</button>';
    }

    html += '<button onclick="window.eventTabsPagination(\'' + tabType + '\', ' + (currentPage + 1) + ')" ' +
            (currentPage === totalPages ? 'disabled' : '') + '>下一页</button>';

    paginationEl.innerHTML = html;
  }

  window.eventTabsPagination = function(tabType, page) {
    var handle = tabType === 'main' ? mainCollectionHandle : pickupCollectionHandle;
    var currentVendor = tabType === 'main' ? currentMainVendor : currentPickupVendor;

    showLoadingOverlay(tabType);

    // Server-side pagination with optional vendor filter
    fetchCollectionData(handle, page, currentVendor).then(function(data) {
      if (tabType === 'main') {
        mainProducts = data.products;
        mainPagination = data.pagination;
        mainCurrentPage = page;
      } else {
        pickupProducts = data.products;
        pickupPagination = data.pagination;
        pickupCurrentPage = page;
      }

      renderProducts(tabType, data.products, data.pagination);

      requestAnimationFrame(function() {
        if (window.EventPricing && window.EventPricing.updateProductGridPrices) {
          window.EventPricing.updateProductGridPrices();
        }
      });

      // Scroll to top of section
      var sectionEl = document.getElementById('event-collection-tabs-' + sectionId);
      if (sectionEl) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  // Store collection handles and pagination info globally
  var mainCollectionHandle = null;
  var pickupCollectionHandle = null;
  var mainPagination = null;
  var pickupPagination = null;

  function loadCollections() {
    var eventData = getEventData();
    mainCollectionHandle = eventData ? eventData.collection : null;
    pickupCollectionHandle = eventData ? eventData.pickup_collection : null;

    console.log('[EventCollectionTabs] eventData:', eventData);
    console.log('[EventCollectionTabs] mainCollectionHandle:', mainCollectionHandle);
    console.log('[EventCollectionTabs] pickupCollectionHandle:', pickupCollectionHandle);

    if (!mainCollectionHandle && !pickupCollectionHandle) {
      var sectionEl = document.getElementById('event-collection-tabs-' + sectionId);
      if (sectionEl) sectionEl.style.display = 'none';
      return;
    }

    Promise.all([
      fetchCollectionData(mainCollectionHandle, 1),
      fetchCollectionData(pickupCollectionHandle, 1)
    ]).then(function(results) {
      var mainData = results[0];
      var pickupData = results[1];

      mainVendors = mainData.vendors;
      pickupVendors = pickupData.vendors;
      mainProducts = mainData.products;
      pickupProducts = pickupData.products;
      mainPagination = mainData.pagination;
      pickupPagination = pickupData.pagination;

      console.log('[EventCollectionTabs] mainPagination:', mainPagination);
      console.log('[EventCollectionTabs] pickupPagination:', pickupPagination);
      console.log('[EventCollectionTabs] mainProducts count:', mainProducts.length);
      console.log('[EventCollectionTabs] pickupProducts count:', pickupProducts.length);

      // Hide pickup tab if no products
      var pickupTabBtn = document.querySelector('#event-tabs-' + sectionId + ' .tab-button[data-tab="pickup"]');
      var pickupTabContent = document.getElementById('tab-pickup');
      var tabNav = document.querySelector('#event-tabs-' + sectionId + ' .tab-nav');

      if (!pickupPagination || pickupPagination.total_items === 0) {
        if (pickupTabBtn) pickupTabBtn.style.display = 'none';
        if (pickupTabContent) pickupTabContent.style.display = 'none';
        // Hide tab nav if only one tab with products
        if (tabNav && mainPagination && mainPagination.total_items > 0) {
          tabNav.style.display = 'none';
        }
      }

      // Hide main tab if no products (edge case)
      var mainTabBtn = document.querySelector('#event-tabs-' + sectionId + ' .tab-button[data-tab="main"]');
      if (!mainPagination || mainPagination.total_items === 0) {
        if (mainTabBtn) mainTabBtn.style.display = 'none';
        // Switch to pickup tab if main is empty but pickup has products
        if (pickupPagination && pickupPagination.total_items > 0) {
          if (tabNav) tabNav.style.display = 'none';
          document.getElementById('tab-main').classList.remove('active');
          document.getElementById('tab-pickup').classList.add('active');
        }
      }

      // Render brand filters
      renderBrandFilter('main', mainVendors);
      renderBrandFilter('pickup', pickupVendors);

      // Render products
      renderProducts('main', mainProducts, mainPagination);
      renderProducts('pickup', pickupProducts, pickupPagination);

      // Update event prices - use same pattern as brand filter and pagination
      requestAnimationFrame(function() {
        if (window.EventPricing && window.EventPricing.updateProductGridPrices) {
          window.EventPricing.updateProductGridPrices();
        }
      });

      // Dispatch event for other listeners
      window.dispatchEvent(new CustomEvent('eventProductsLoaded', {
        detail: {
          mainCount: mainPagination ? mainPagination.total_items : mainProducts.length,
          pickupCount: pickupPagination ? pickupPagination.total_items : pickupProducts.length,
          sectionId: sectionId
        }
      }));
    }).catch(function(error) {
      console.error('[EventCollectionTabs] Error:', error);
      showErrorState('main');
      showErrorState('pickup');
    });
  }

  // Get URL parameter
  function getUrlParam(name) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  var loaded = false;
  function init() {
    if (loaded) return;
    var eventData = getEventData();
    if (eventData && (eventData.collection || eventData.pickup_collection)) {
      loaded = true;
      // Set activeTab based on URL param (tab already set by inline script in liquid)
      var tabParam = getUrlParam('tab');
      if (tabParam === 'pickup' || tabParam === 'main') {
        activeTab = tabParam;
      }
      loadCollections();
    }
  }

  window.addEventListener('eventDataReady', init);
  init();
})();
